import { useCallback, useEffect, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import Alert from './components/Alert';
import Footer from './components/form/footer';
import jwt_decode from 'jwt-decode';


function App() {

  const [jwtToken, setJwtToken] = useState(""); // storage for jwt token
  const [alertMessage, setAlertMessage] = useState(""); //storage for alert message
  const [alertClassName, setAlertClassName] = useState("d-none");

  const [tickInterval, setTickInterval] = useState(); // storage for refresh token interval

  // info about user
  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    tokens: 0,
    tokensPerDayLimit: 0,
    wordsToSearchLimit: 0,
    storageLimit: 0,
    role: "",
  })

  const navigate = useNavigate();

  //  ticker to refresh token-----------------------------------------
  // this func is passed to useEffect refresh function
  const toggleRefresh = useCallback((status) => {

    // if status is true, turn on timer
    if (status) {
      let i = setInterval(() => {
        // create request options
        const requestOptions = {
          method: "GET",
          credentials: "include",
        }
        // send request with options
        fetch(`${process.env.REACT_APP_BACKEND}/api/refresh`, requestOptions)
          // convert response to json
          .then((response) => response.json())
          // if there is token in response, set it
          .then((data) => {
            if (data.access_token) {
              setJwtToken(data.access_token);
            }
          })
          .catch(error => {
            console.log("can't refresh token, user is not logged in");
          })
      }, 540000); // set interval to 9 minutes
      setTickInterval(i);
    } else {
      setTickInterval(null);
      clearInterval(tickInterval);
    }
  }, [tickInterval])

  // LogOut user 
  const logOut = () => {
    // create request options
    const requestOptions = {
      method: "GET",
      credentials: "include",
    }
    // send request with options
    fetch(`${process.env.REACT_APP_BACKEND}/api/logout`, requestOptions)
      .catch(error => {
        console.log("error logging out", error);
      })
      // executes anyway
      .finally((() => {
        setJwtToken("");
        setUserInfo({ role: "user" })
        toggleRefresh(false); // stop refreshing jwt
      }))
    navigate("/login");
  }

  //  Refresh jwtToken and activates auto refreshing 
  useEffect(() => {
    // create request options
    if (jwtToken === "") {
      const requestOptions = {
        method: "GET",
        credentials: "include",
      }
      // send request with options
      fetch(`${process.env.REACT_APP_BACKEND}/api/refresh`, requestOptions)
        // convert response to json
        .then((response) => response.json())
        // if there is token in response, set it
        .then((data) => {
          if (data.access_token) {
            setJwtToken(data.access_token);
            var decoded = jwt_decode(data.access_token); // decode jwt token and define user's role
            setUserInfo({ role: decoded.rol });
            toggleRefresh(true); // start refreshing token every 10 minutes
          }
        })
        .catch(error => {
          console.log("can't refresh token, user is not logged in", error);
        })
    }
  }, [jwtToken, toggleRefresh, setUserInfo])

  // Get user info if loged in 
  useEffect(() => {

    if (jwtToken === "") {
      return;
    }
    // create headers
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + jwtToken);

    const requestOptions = {
      method: "GET",
      headers: headers,
      credentials: "include",
    }

    // send request with options
    fetch(`${process.env.REACT_APP_BACKEND}/api/ar/user-info`, requestOptions)
      // convert response to json
      .then((response) => response.json())
      // if there is token in response, set it
      .then((data) => {
        if (data.err) {
          console.log(data.err);
        } else {
          setUserInfo({
            role: userInfo.role,
            firstName: data.first_name,
            lastName: data.last_name,
            tokens: data.tokens,
            tokensPerDayLimit: data.tokens_per_day_limit,
            wordsToSearchLimit: data.words_to_search_limit,
            storageLimit: data.storage_limit,
            scheduledTasksLimit: data.scheduled_tasks_limit
          });
        }
      })
      .catch(error => {
        console.log("cant get user info", error);
      })

  }, [jwtToken, userInfo.role])

  return (
    <div className="container">
      <div className="row">

        <div className="col-6">
          <h1 className='display-4' style={{ fontFamily: 'Constantia', color: '#454545'}}>VIRGILIA</h1>
        </div>

        <div className="col-2 text-end">
          {jwtToken !== "" && (
            userInfo.role === "premium-user"
              ? <h6 className="mt-4"><i className="bi bi-stars text-primary"></i>{userInfo.firstName} {userInfo.lastName}</h6>
              : <h6 className="mt-4">{userInfo.firstName} {userInfo.lastName}</h6>
          )}
        </div>

        <div className="col-2">
          {jwtToken !== "" &&
            <h6 className="mt-4">Tokens left: {userInfo.tokens} / {userInfo.tokensPerDayLimit}</h6>
          }
        </div>

        <div className="col-1 mt-3 text-end">
          {jwtToken === "" &&
            <Link to="/signup"><h5><span className="badge bg-primary">Sign Up</span></h5></Link>
          }
        </div>

        <div className="col-1 mt-3 text-end">
          {jwtToken === ""
            ? <Link to="/login"><h5><span className="badge bg-success">Log In</span></h5></Link>
            : <a href='#!' onClick={logOut}><h5><span className='badge bg-danger'>Log Out</span></h5></a>
          }
        </div>

        <hr className="mb-3"></hr>
      </div>

      <div className="row">
        <div className="col-md-2">
          <nav className="list-group">
            <Link to="/" className="list-group-item list-group-item-action">Home</Link>
            {jwtToken !== "" &&
              <>
                <Link to="/search" className="list-group-item list-group-item-action">Search</Link>
                <Link to="/scheduled-tasks" className="list-group-item list-group-item-action">Scheduled tasks</Link>
                <Link to="/reports-storage" className="list-group-item list-group-item-action">Reports storage</Link>
              </>
            }
            <Link to="/about" className="list-group-item list-group-item-action">About</Link>
          </nav>
        </div>
        <div className="col-md-10">
          <Alert
            message={alertMessage}
            className={alertClassName}
          />
          {/* give access to this functions in components*/}
          <Outlet context={{
            jwtToken,
            setJwtToken,
            userInfo,
            setUserInfo,
            setAlertClassName,
            setAlertMessage,
            toggleRefresh,
          }} />
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
